"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityDetailGroup = void 0;
const tslib_1 = require("tslib");
/* eslint-disable deprecation/deprecation */
const react_1 = tslib_1.__importDefault(require("react"));
const DataQualityStyles_1 = require("../style/DataQualityStyles");
const DataQualityDetail_1 = require("./DataQualityDetail");
/**
 * @deprecated TFS-1478812
 */
function DataQualityDetailGroup(props) {
    if (props.details.length > 0) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DataQualityStyles_1.DataQualityDetailGroupHeadingDiv, null, props.message),
            react_1.default.createElement(DataQualityStyles_1.DataQualityDetailGroupDiv, null, props.details.map((detail, index, _) => (react_1.default.createElement(DataQualityDetail_1.DataQualityDetail, Object.assign({ key: props.keyPrefix + index.toString() }, detail, { linksDisabled: props.linksDisabled })))))));
    }
    return null;
}
exports.DataQualityDetailGroup = DataQualityDetailGroup;
//# sourceMappingURL=DataQualityDetailGroup.js.map